import { SvgIconProps } from "@mui/material";
import WarningIcon from "components/Icons/SystemMessaging/WarningIcon";
import Div from "components/primitives/Div";
import type { DivProps } from "components/primitives/Div";

function Warning(props: DivProps & { iconProps?: SvgIconProps }) {
  const { children, sx, iconProps, ...rest } = props;

  return (
    <Div
      role="alert"
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: "4px",
        padding: "4px 8px",
        backgroundColor: "warning.light",
        ...sx,
      }}
      {...rest}
    >
      <Div sx={{ display: "flex", alignItems: "center", marginRight: "4px", lineHeight: 0 }}>
        <WarningIcon fontSize="small" color="warning" sx={{ lineHeight: 0 }} {...iconProps} />
      </Div>
      {children}
    </Div>
  );
}

export default Warning;
